import styled, { keyframes, css } from 'styled-components'

// ── paleta (alinhada à central) ────────────────────────────────────
const TEAL = 'var(--teal)'
const TEAL_TEXT = 'var(--teal-text, var(--teal))';
const TEAL_LIGHT = 'var(--teal-light)'
const TEAL_SOFT = 'var(--teal-soft)'
const GRAY_BG = 'var(--bg)'
const GRAY_LINE = 'var(--line)'
const GRAY_TEXT = 'var(--text-muted)'
const GREEN = 'var(--green)'
const GREEN_SOFT = 'var(--green-soft)'
const AMBER_SOFT = '#fdf3e0'
const AMBER = 'var(--amber, #d97706)'
const RED = 'var(--red, #dc2626)'

const bp = { tablet: '768px', mobile: '540px', small: '380px' }

const expand = keyframes`
    from { opacity: 0; transform: translateY(-6px); }
    to   { opacity: 1; transform: translateY(0); }
`
const shimmer = keyframes`
    0% { background-position: -400px 0; } 100% { background-position: 400px 0; }
`

export const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    background: ${GRAY_BG};
    display: flex;
    justify-content: center;
    padding: 16px;
    box-sizing: border-box;

    @media (max-width: ${bp.mobile}) { padding: 8px; }
    @media print { padding: 0; margin: 0; background: var(--surface); }
`

export const ContainerDivs = styled.div`
    width: 100%;
    max-width: 980px;
    display: flex;
    flex-direction: column;
    gap: 14px;

    @media (max-width: ${bp.mobile}) { gap: 10px; }
    @media print { gap: 8px; max-width: 100%; }
`

/* ── Header ─────────────────────────────────────────────────────── */

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 20px;
    background: ${TEAL};
    color: #fff;
    border-radius: 14px;
    box-shadow: 0 6px 18px rgba(0,62,79,.18);
    flex-wrap: wrap;

    @media (max-width: ${bp.mobile}) { padding: 14px 16px; border-radius: 12px; }
    @media print {
        background: var(--surface); color: var(--text, var(--text-muted)); box-shadow: none;
        border-bottom: 2px solid #000; border-radius: 0; padding: 8px 0;
    }
`

export const HeaderInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
`

export const Title = styled.h1`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    @media (max-width: ${bp.mobile}) { font-size: 17px; }
`

export const Subtitle = styled.span`
    font-size: 12px;
    font-weight: 600;
    opacity: .85;
    text-transform: uppercase;
    letter-spacing: .4px;
`

export const HeaderBack = styled.button`
    background: rgba(255,255,255,.16);
    border: none;
    color: #fff;
    width: 40px; height: 40px;
    border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    transition: background .15s ease;
    &:hover { background: rgba(255,255,255,.28); }
    @media print { display: none; }
`

/* mantém StudentSection como wrapper neutro */
export const StudentSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    h2 { display: none; } /* título agora vem do Header */
    @media print { gap: 8px; }
`

/* ── Busca por data ─────────────────────────────────────────────── */

export const SearchBar = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 12px;
    padding: 12px 14px;
    flex-wrap: wrap;

    label { font-size: 12px; font-weight: 700; color: ${GRAY_TEXT};
            text-transform: uppercase; letter-spacing: .3px; }

    input[type="date"] {
        flex: 1; min-width: 180px;
        border: 1px solid ${GRAY_LINE};
        border-radius: 8px;
        padding: 10px 12px;
        font-size: 14px;
        color: ${TEAL_TEXT};
        outline: none;
        &:focus { border-color: ${TEAL_LIGHT}; box-shadow: 0 0 0 3px rgba(10,90,115,.1); }
        @media (max-width: ${bp.mobile}) { min-width: 100%; font-size: 16px; min-height: 44px; }
    }
    @media print { display: none; }
`

export const ClearSearch = styled.button`
    background: var(--surface-2);
    border: 1px solid ${GRAY_LINE};
    color: ${GRAY_TEXT};
    border-radius: 8px;
    padding: 9px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    &:hover { background: var(--surface-2); }
`

/* mantém Table/DivButton como wrappers de layout */
export const Table = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    @media print { gap: 6px; }
`
export const DivButton = styled.div`
    display: none; /* navegação foi para o Header */
`

/* ── Seção título (Aulas / Dias sem aula) ──────────────────────── */

export const SectionTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 12px 16px;
    background: ${({ $tone }) => ($tone === 'pending' ? AMBER_SOFT : GREEN_SOFT)};
    border: 1px solid ${GRAY_LINE};
    border-radius: 12px;
    flex-wrap: wrap;

    h3 { margin: 0; font-size: 14px; font-weight: 700;
         color: ${({ $tone }) => ($tone === 'pending' ? AMBER : GREEN)};
         display: flex; align-items: center; gap: 8px; }
    @media print {
        background: var(--surface); border: none; border-bottom: 1px solid #000;
        border-radius: 0; padding: 6px 0;
        h3 { color: var(--text, var(--text-muted)); font-size: 13pt; }
    }
`

export const CountBadge = styled.span`
    background: ${({ $tone }) => ($tone === 'pending' ? '#f2d9a8' : '#cdeac8')};
    color: ${({ $tone }) => ($tone === 'pending' ? AMBER : GREEN)};
    font-size: 12px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 999px;
    white-space: nowrap;
    @media print { display: none; }
`

/* ── Registrar nova aula ───────────────────────────────────────── */

export const Register = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    /* busca à esquerda, botão de registrar à direita (mesma linha) */
    > div:first-child { flex: 1 1 320px; }
    @media print { display: none; }
`

export const ButtonReg = styled.button`
    background: ${GREEN};
    color: #fff;
    border: none;
    padding: 11px 20px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    border-radius: 10px;
    min-height: 44px;
    transition: filter .12s ease, transform .12s ease;
    &:hover { filter: brightness(1.08); transform: translateY(-1px); }
    &:active { transform: translateY(0); }
    @media (max-width: ${bp.mobile}) { width: 100%; }
    @media print { display: none; }
`

/* ── Card de aula ───────────────────────────────────────────────── */

export const ContainerTable = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-left: 4px solid ${({ $pending, $warn }) => ($warn ? 'var(--orange, #e67e22)' : $pending ? AMBER : TEAL_LIGHT)};
    ${({ $warn }) => $warn && 'background: var(--orange-soft, #fff1e0); border-color: var(--orange, #e67e22);'}
    border-radius: 12px;
    padding: 14px 16px;
    transition: box-shadow .12s ease, transform .12s ease;
    &:hover { box-shadow: 0 4px 14px rgba(0,0,0,.06); }

    @media (max-width: ${bp.mobile}) { padding: 12px 14px; }
    @media print {
        border: none; border-bottom: 1px solid var(--line); border-radius: 0;
        padding: 8px 0; box-shadow: none !important;
        page-break-inside: avoid; break-inside: avoid;
    }
`

export const Span = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px 18px;
    font-size: 12px;
    color: ${GRAY_TEXT};
    margin-bottom: 8px;

    div { display: flex; align-items: center; gap: 4px; }
    p { margin: 0; font-weight: 700; color: ${TEAL_TEXT}; }

    @media print { font-size: 10pt; color: var(--text, var(--text-muted)); p { color: var(--text, var(--text-muted)); } }
    @media (max-width: ${bp.small}) { font-size: 11px; }
`

export const TableRow = styled.div`
    display: flex;
    gap: 14px;
    align-items: flex-start;

    @media (max-width: ${bp.mobile}) { flex-direction: column; gap: 8px; }
`

export const DateCell = styled.div`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 700;
    font-size: 14px;
    color: ${TEAL_LIGHT};
    background: ${TEAL_SOFT};
    padding: 6px 12px;
    border-radius: 8px;
    white-space: nowrap;

    @media print { background: var(--surface); color: var(--text, var(--text-muted)); padding: 0; font-size: 11pt; }
`

/* aula registrada em dia que NÃO é letivo */
export const WarnTag = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: var(--orange, #d35400);
    @media print { display: none; }
`

export const DescriptionCell = styled.div`
    flex: 1;
    min-width: 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
    text-align: left;

    .description {
        color: ${TEAL_TEXT};
        line-height: 1.6;
        font-size: 14px;
        * { color: ${TEAL_TEXT}; }
        white-space: pre-wrap;
        word-break: break-word;
        overflow: hidden;
        transition: max-height .3s ease;

        &.collapsed { display: -webkit-box; -webkit-box-orient: vertical;
                      -webkit-line-clamp: 3; max-height: 4.8em; }
        &.expanded { -webkit-line-clamp: unset; max-height: none; }

        @media print {
            color: var(--text, var(--text-muted)) !important; * { color: var(--text, var(--text-muted)) !important; }
            -webkit-line-clamp: unset; max-height: none;
            white-space: pre-wrap; font-size: 12pt;
        }
        @media (max-width: ${bp.small}) { font-size: 13px; }
    }
`

export const CardActions = styled.div`
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed ${GRAY_LINE};
    @media print { display: none; }
`

/* ── Botões ─────────────────────────────────────────────────────── */

const btnBase = css`
    border: none;
    padding: 8px 16px;
    cursor: pointer;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    min-height: 38px;
    transition: filter .12s ease, transform .12s ease, background .12s ease;
    &:active { transform: translateY(1px); }
    &:disabled { opacity: .6; pointer-events: none; }
    @media print { display: none; }
    @media (max-width: ${bp.mobile}) { min-height: 42px; }
`

// Botão neutro (Ver mais / Registrar / ações na linha de pendentes)
export const Button = styled.button`
    ${btnBase}
    background: ${TEAL};
    color: #fff;
    &:hover { filter: brightness(1.1); }
`

// Botão de edição/ações do modal
export const ButtonEdit = styled.button`
    ${btnBase}
    background: ${TEAL};
    color: #fff;
    &:hover { filter: brightness(1.1); }
`

// variantes auxiliares (usadas via prop)
export const ActionGhost = styled.button`
    ${btnBase}
    background: var(--surface-2);
    color: ${GRAY_TEXT};
    border: 1px solid ${GRAY_LINE};
    &:hover { background: var(--surface-2); }
`
export const ActionDanger = styled.button`
    ${btnBase}
    background: var(--red-soft);
    color: ${RED};
    border: 1px solid var(--red);
    &:hover { filter: brightness(.97); }
`

export const ShowMoreButton = styled.button`
    background: var(--surface);
    color: ${TEAL_TEXT};
    border: 1px solid ${TEAL_LIGHT};
    padding: 11px 24px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    border-radius: 10px;
    margin: 6px auto;
    display: block;
    min-height: 44px;
    transition: background .15s ease;
    &:hover { background: ${TEAL_SOFT}; }
    @media (max-width: ${bp.mobile}) { width: 100%; }
    @media print { display: none; }
`

export const InfoText = styled.div`
    color: ${GRAY_TEXT};
    font-size: 14px;
    text-align: center;
    padding: 18px;
    background: var(--surface);
    border: 1px dashed ${GRAY_LINE};
    border-radius: 12px;
    @media print { display: none; }
`

/* ── Modal de edição ────────────────────────────────────────────── */

export const EditContainer = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,.4);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    padding: 16px;

    .ql-toolbar.ql-snow {
        display: flex; flex-wrap: wrap; gap: 2px;
        border-radius: 8px 8px 0 0; border-color: ${GRAY_LINE};
        background: var(--surface); position: sticky; top: 0; z-index: 2;
    }
    .ql-container.ql-snow { border-radius: 0 0 8px 8px; border-color: ${GRAY_LINE}; }
    .ql-editor { min-height: 220px; line-height: 1.6; color: ${TEAL_TEXT}; font-size: 15px; }

    .modal-content {
        background: var(--surface);
        border: none;
        padding: 22px;
        width: 100%;
        max-width: 680px;
        max-height: 90vh;
        overflow-y: auto;
        border-radius: 14px;
        box-shadow: 0 12px 40px rgba(0,0,0,.2);
        display: flex;
        flex-direction: column;
        animation: ${expand} .2s ease;

        h3 { margin: 0 0 16px; color: ${TEAL_TEXT}; font-size: 18px;
             padding-bottom: 12px; border-bottom: 1px solid ${GRAY_LINE}; }

        .BoxBtt {
            display: flex; gap: 10px;
            justify-content: flex-end;
            margin-top: 18px; padding-top: 14px;
            border-top: 1px solid ${GRAY_LINE};
        }

        @media (max-width: ${bp.mobile}) {
            padding: 16px; border-radius: 14px 14px 0 0;
            max-height: 95vh; align-self: flex-end;
            h3 { font-size: 16px; }
            .BoxBtt { flex-direction: column-reverse; button { width: 100%; } }
        }
    }
    @media (max-width: ${bp.mobile}) { padding: 0; align-items: flex-end; }
    @media print { display: none; }
`

export const ContainerDelet = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 14px;
    padding: 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    text-align: center;

    h2 { margin: 0; color: ${RED}; font-size: 20px; }
    h4 { margin: 0; color: ${GRAY_TEXT}; font-weight: 500; line-height: 1.5; }

    @media (max-width: ${bp.mobile}) { padding: 20px 16px; }
    @media print { display: none; }
`

export const ErrorMessage = styled.div`
    background: var(--red-soft);
    color: ${RED};
    border: 1px solid var(--red);
    padding: 10px 12px;
    border-radius: 8px;
    font-size: 13px;
    text-align: center;
    margin-top: 12px;
    @media print { display: none; }
`

/* ── Skeleton ───────────────────────────────────────────────────── */

const skeletonBase = css`
    background: linear-gradient(90deg,var(--surface-2) 0%,#f6f8f9 50%,var(--surface-2) 100%);
    background-size: 800px 100%;
    animation: ${shimmer} 1.3s linear infinite;
    border-radius: 8px;
`
export const SkeletonLine = styled.div`
    ${skeletonBase}
    height: ${({ $h }) => $h || '14px'};
    width: ${({ $w }) => $w || '100%'};
    margin: 4px 0;
`
export const SkeletonCard = styled.div`
    background: var(--surface); border: 1px solid ${GRAY_LINE}; border-radius: 12px;
    padding: 16px; display: flex; flex-direction: column; gap: 8px;
`

/* ── Print helpers / voltar ─────────────────────────────────────── */

export const PrintOnly = styled.div`
    display: none;
    @media print { display: block; }
`
export const HiddenOnPrint = styled.div`
    @media print { display: none; }
`
export const ExpandedDescription = styled.div`
    @media print { white-space: pre-wrap; word-wrap: break-word; }
`

export const ToGoBack = styled.div`
    display: flex;
    gap: 6px;
    align-items: center;
    justify-content: center;
    padding: 14px 8px;
    cursor: pointer;
    color: ${GRAY_TEXT};
    min-height: 44px;
    &:hover { color: ${TEAL_TEXT}; }
    @media print { display: none; }
`
export const SignMessageButtonText = styled.span``
export const SignMessageButtonTextBold = styled.span`
    font-weight: 700; color: ${TEAL_TEXT}; margin-left: 4px;
`